export default __webpack_public_path__ + "static/media/34-CN.79422d10.jpg";